import { EntityId } from 'entities-next/common'
import { QueryClient } from 'react-query'

export function deleteEntityFromListCache(queryClient: QueryClient, entityId: EntityId, queryKey: any) {
  queryClient.setQueryData(queryKey, (cache: any[] = []) => {
    return cache.filter((row) => {
      return row.id !== entityId
    })
  })
}

export function deleteEntityFromCache(queryClient: QueryClient, entityId: EntityId, listQueryKey: string) {
  queryClient.setQueryData([entityId, listQueryKey], (cache: any[] = []) => cache.filter((row) => row.id !== entityId))
}
